import cn from 'classnames';
// UI
import MillionsIcon from 'ui3/MillionsIcon/MillionsIcon';
import Text from 'ui3/Text/Text';
// Styles
import styles from './SecurePayments.module.scss';

type SecurePaymentsProps = {
  className?: string;
};

const paymentMethods = [
  { name: 'visa', label: 'Visa' },
  { name: 'mastercard', label: 'Mastercard' },
  { name: 'amex', label: 'American Express' },
] as const;

const SecurePayments = ({ className }: SecurePaymentsProps) => {
  return (
    <div className={cn(styles.root, className)}>
      <Text variant="body2Medium" className={styles.desktopDescription}>
        Secured and Trusted Checkout With:
      </Text>
      <Text variant="body2Medium" className={styles.mobileDescription}>
        Secured and Trusted Checkout:
      </Text>

      <div className={styles.logosWrapper}>
        {paymentMethods.map(({ name, label }) => (
          <span
            key={name}
            className={cn(styles.logoCard, {
              [styles.logoCardAmex]: name === 'amex',
            })}
            role="img"
            aria-label={label}
          >
            <MillionsIcon name={name} className={styles.logo} />
          </span>
        ))}
      </div>
    </div>
  );
};

export default SecurePayments;
